module.exports = __webpack_public_path__ + "static/eido-178b63f28160da7ed8b20fa9e0cd0691.png";